"use strict";
/**
 * @module indicative-rules
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
* indicative-rules
*
* (c) Harminder Virk <virk@adonisjs.com>
*
* For the full copyright and license information, please view the LICENSE
* file that was distributed with this source code.
*/
const isCreditCard_1 = __importDefault(require("validator/lib/isCreditCard"));
/**
 * Returns a boolean telling, if value is a valid credit card number pattern
 * or not.
 *
 * @example
 * ```js
 * const { is } = require('indicative')
 *
 * if (is.creditCard('4111-1111-1111-1111')) {
 * }
 * ```
 */
exports.creditCard = (input) => isCreditCard_1.default(input);
